<template>
<svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.5005 44C35.5462 44 44.5005 35.0457 44.5005 24C44.5005 12.9543 35.5462 4 24.5005 4C13.4548 4 4.50049 12.9543 4.50049 24C4.50049 35.0457 13.4548 44 24.5005 44Z" stroke="#FFDE99" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M24.5 16.5V27" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M24.5 32.25H24.5106" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>

<script>
export default {
    props: {
        size: {
            default: '24',
        },
        color: {
            default: '#E19700'
        }
    }
}
</script>

<style>

</style>
